import { forwardRef, ReactNode } from 'react';

export const Form = forwardRef<HTMLFormElement, { children: ReactNode }>(
  ({ children }, ref) => {
    return (
      <form
        ref={ref}
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {children}
      </form>
    );
  },
);

Form.displayName = 'Form';
